import React from 'react';
import { StyleSheet } from 'react-native';
import { HStack, VStack, Box } from 'native-base';
import { get } from 'lodash';
import { colors, Typography, Iconography, DashedCircleMobile } from 'fmc-digital-common';
const styles = StyleSheet.create({
  stepContainer: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  inner: {
    width: 38,
    height: 38,
    margin: 2
  }
});
const LoanStatusStep = props => {
  const {
    loanTrackingData
  } = props;
  const inProgress = loanTrackingData?.filter(data => data.state === 'InProgress' || data.state === 'Completed' && data.step === loanTrackingData.length);
  let step = '';
  let text = '';
  let state = '';
  if (inProgress && inProgress.length) {
    step = inProgress[0]?.step;
    text = inProgress[0]?.text;
    state = inProgress[0]?.state;
  }
  return /*#__PURE__*/React.createElement(Box, {
    paddingX: 4,
    pb: 4,
    testID: "status-tracker-mobile-container"
  }, /*#__PURE__*/React.createElement(HStack, {
    space: "2"
  }, /*#__PURE__*/React.createElement(Box, {
    style: styles.stepContainer
  }, /*#__PURE__*/React.createElement(DashedCircleMobile, {
    color: state === 'Completed' ? get(colors, 'success.300', '') : get(colors, 'darkGray.900', ''),
    width: 48,
    height: 48,
    testID: `dashed-circle-${state}`
  }), /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    rounded: "full",
    justifyContent: "center",
    alignItems: "center",
    bg: state === 'Completed' ? 'success.300' : 'blue.900',
    style: styles.inner,
    testID: "step-inner-container"
  }, state === 'Completed' ? /*#__PURE__*/React.createElement(Iconography, {
    name: "check",
    size: 24,
    color: "white.500"
  }) : /*#__PURE__*/React.createElement(Typography, {
    variant: "trackerItem",
    color: "white.500",
    noOfLines: 2,
    testID: "status-tracker-step",
    accessibilityRole: "text",
    accessibilityLabel: "Step Number"
  }, step))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(VStack, {
    space: "1"
  }, /*#__PURE__*/React.createElement(Box, {
    pt: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    fontSize: 13,
    color: state === 'Completed' ? 'success.300' : 'blue.900',
    testID: "status-tracker-info-text",
    accessibilityRole: "text",
    accessibilityLabel: "Loan Info"
  }, "Step ", step, " of ", loanTrackingData?.length)), /*#__PURE__*/React.createElement(Typography, {
    variant: "regularBold",
    color: state === 'Completed' ? 'success.300' : 'blue.900',
    textAlign: "left",
    fontSize: 16,
    testID: "status-tracker-text",
    accessibilityRole: "text",
    accessibilityLabel: "Loan Progress"
  }, text)))));
};
export default /*#__PURE__*/React.memo(LoanStatusStep);
//# sourceMappingURL=LoanStatusStep.js.map